export default function isStreamMonkey(migrationId = '') {
  if (!migrationId) return false;

  const migrationIdChunks = migrationId.split(':');
  return migrationIdChunks[0].toLowerCase() === 'sm';
}



// WEBPACK FOOTER //
// ./app/utils/isStreamMonkey.js